import React from 'react';
// AdvancedMarker must be imported from MapViewWeb's re-export, not directly from
// @vis.gl/react-google-maps -- see MapViewWeb.js:218-221 for why (context mismatch).
import { AdvancedMarker } from './MapViewWeb';
import { getIconUri } from './MemoizedPantryMarkerUtils';
import { SiteMarkerProps } from './SiteMarker.native';
import getSiteMarkerIcon from './siteMarkerIcon';
import { siteMarkerPropsAreEqual } from './siteMarkerPropsAreEqual';

export type { SiteMarkerProps };

const iconStyle = { width: 28, height: 'auto' };

const SiteMarker = React.memo(({ site, isSelected, onPress }: SiteMarkerProps) => {
  const iconUri = getIconUri(getSiteMarkerIcon(site.source, isSelected));
  // `onPress` (the stable, unbound onMarkerPress from SiteMap) is bound to this specific site
  // here, inside the memoized component, rather than by the caller -- binding it upstream would
  // create a new function on every render there, defeating siteMarkerPropsAreEqual.
  const handlePress = () => onPress(site);

  return (
    <AdvancedMarker
      position={{ lat: site.coordinate.latitude, lng: site.coordinate.longitude }}
      title={site.name}
      onClick={handlePress}
      zIndex={isSelected ? 1 : 0}
    >
      <img src={iconUri} style={iconStyle} alt={site.name} />
    </AdvancedMarker>
  );
}, siteMarkerPropsAreEqual);

export default SiteMarker;
